import { useRef } from "react";

import LeftArrowSVG from "../SVG/LeftArrowSVG";
import RightArrowSVG from "../SVG/RightArrowSVG";
import { staffData } from "../../Data/StaffData";
import Section from "../Section";

const StaffGallery = () => {
  // const { ref, inView } = useInView({
  //   triggerOnce: true,
  //   threshold: 0.5,
  // });

  const scrollContainerRef = useRef(null);

  const handleScroll = (direction) => {
    const scrollAmount = scrollContainerRef.current.clientWidth; // Scroll one full image width
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <Section bg="bg-inherit">
      <div className="col-span-10 col-start-2 h-[2px] bg-black opacity-30 " />
      <div className="col-span-10 col-start-2 relative py-8">
        {/* Left Scroll Button (Hidden on Mobile) */}
        <button
          onClick={() => handleScroll("left")}
          className="hidden absolute -left-20 top-1/2 transform -translate-y-1/2 bg-primary-light text-primary-orange border-2 p-6 rounded-full z-10 transition rotate-180 xl:flex items-center justify-center opacity-50 hover:opacity-90"
        >
          <LeftArrowSVG size={26} />
        </button>

        {/* Scrollable Container */}
        <div
          ref={scrollContainerRef}
          className="flex items-center gap-20 overflow-x-auto xl:overflow-hidden snap-x snap-mandatory scroll-smooth py-12 scrollbar-hide"
        >
          {staffData.map((staff, index) => (
            <div
              key={staff.id}
              className={`flex flex-col items-center gap-4 text-primary-dark flex-shrink-0 snap-center w-96 sm:w-auto rounded-xl`}
            >
              <div
                className={`transition-all transform duration-300 ease-in-out h-full w-fit max-w-96 bg-black flex-shrink-0 rounded-xl`}
              >
                <img
                  src={staff.img}
                  alt={`Gallery ${index + 1}`}
                  loading="lazy"
                  className="h-[432px] w-auto object-cover duration-500 ease-in-out transform hover:opacity-80 rounded-xl"
                />
              </div>
              {/* <strong className="font-gilroy text-2xl tracking-wider">
                {staff.name}
              </strong>
              <p className="text-center text-nowrap">{staff.position}</p> */}
            </div>
          ))}
        </div>

        {/* Right Scroll Button (Hidden on Mobile) */}
        <button
          onClick={() => handleScroll("right")}
          className="hidden absolute -right-20 top-1/2 transform -translate-y-1/2 bg-primary-light text-primary-orange border-2  p-6 rounded-full z-10 transition xl:flex items-center justify-center opacity-50 hover:opacity-90"
        >
          <RightArrowSVG size={26} />
        </button>
      </div>
    </Section>
  );
};

export default StaffGallery;
